
export enum ClaimExternalVisibilityCd {
	REGISTERED_EXTERNAL_USER = 'RegisteredExternalUser',
	UNREGISTERED_EXTERNAL_USER = 'UnregisteredExternalUser'}

